<script setup lang="ts">
import { useTrustpilotFrameTitle } from '~/composables/useTrustpilotFrameTitle'

const props = defineProps<{ html: string }>()
const container = ref<HTMLElement | null>(null)

// Render only the .trustpilot-widget element, dropping any authored wrapper
// (e.g. an <h4> title) the PIM bakes into the embed HTML.
const widgetHtml = computed(() => {
  if (!import.meta.client)
    return props.html
  const tpl = document.createElement('template')
  tpl.innerHTML = props.html
  return tpl.content.querySelector('.trustpilot-widget')?.outerHTML ?? props.html
})

useTrustpilotFrameTitle(container)

// The bootstrap is loaded by the GTM container; the gate renders this only once
// window.Trustpilot is ready, so initialise the widget on mount.
onMounted(() => {
  const tp = (globalThis as any).Trustpilot
  const widget = container.value?.querySelector('.trustpilot-widget')
  if (tp && widget)
    tp.loadFromElement(widget, true)
})
</script>

<template>
  <div
    ref="container"
    v-html="widgetHtml"
  />
</template>
